import { useMemo } from "react"

interface Props {
  showTitle?: boolean
}

export const PrivacyPolicy: React.FC<Props> = ({ showTitle = true }) => {
  const currentDate = useMemo(() => {
    const currrentMonthName = new Date().toLocaleString("default", { month: "long" })
    const currentDay = new Date().getDate()
    const currentYear = new Date().getFullYear()
    return `${currrentMonthName} ${currentDay}, ${currentYear}`
  }, [])

  return (
    <div className="space-y-4">
      {showTitle && <h1 className="text-2xl font-bold">🔒 PRIVACY POLICY — T4Ever</h1>}

      <p className="text-sm">Last updated: {currentDate}</p>

      <p>
        At Legacy IA, we respect your privacy and are committed to protecting the personal information you
        share with us when using the T4Ever software.
      </p>

      <h4 className="font-bold">1. Information We Collect</h4>

      <p>We may collect the following types of information:</p>

      <ul className="ps-5 list-disc ms-5">
        <li>
          <span className="font-semibold">Personal Data:</span> name, email address, and other registration
          data.
        </li>
        <li>
          <span className="font-semibold">Technical Data:</span> IP address, device type, operating system,
          and service usage.
        </li>
        <li>
          <span className="font-semibold">AI-Generated Data:</span> content or queries you make within T4Ever.
        </li>
      </ul>

      <h4 className="font-bold">2. Use of Information</h4>

      <p>We use this information to:</p>

      <ul className="ps-5 list-disc ms-5">
        <li>Provide, maintain, and improve T4Ever.</li>
        <li>Personalize your user experience.</li>
        <li>Communicate with you about updates or technical support.</li>
        <li>Comply with legal or security obligations.</li>
      </ul>

      <h4 className="font-bold">3. Storage and Security</h4>

      <p>
        Your data is stored on secure servers and handled with appropriate technical and organizational
        measures to protect it from unauthorized access or loss.
      </p>

      <h4 className="font-bold">4. Information Sharing</h4>

      <p>We do not sell your personal data. We only share it with:</p>

      <ul className="ps-5 list-disc ms-5">
        <li>Service providers that help operate T4Ever (such as cloud storage).</li>
        <li>Authorities, when required by law.</li>
      </ul>

      <h4 className="font-bold">5. User Rights</h4>

      <p>You have the right to:</p>

      <ul className="ps-5 list-disc ms-5">
        <li>Access, correct, or delete your personal data.</li>
        <li>Withdraw your consent to the processing of your data.</li>
        <li>Request a copy of your data.</li>
      </ul>

      <p>
        To exercise these rights, please write to: 📩 <b>privacidad@example.com</b>
      </p>

      <h4 className="font-bold">6. Cookies</h4>

      <p>
        T4Ever may use cookies or similar technologies to enhance the user experience and analyze site usage.
        You can set your browser to reject them.
      </p>

      <h4 className="font-bold">7. Changes to this Policy</h4>

      <p>
        We may update this Privacy Policy when necessary. The current version will always be posted on our
        website.
      </p>

      <h4 className="font-bold">8. Contact</h4>

      <p>If you have any questions about this policy, please contact us at: 📩 privacy@legacyia.com</p>
    </div>
  )
}
